<template>
  <v-skeleton-loader
    class="inplay-match upcoming-play"
    tile
    light
    dense
    :loading="loading"
    type="list-item-two-line, list-item-two-line"
  >
    <v-card
      v-if="upcomingMarkets && upcomingMarkets.length"
      light
      tile
      flat
      outlined
    >
      <template v-for="(key, i) in ['4', '1', '2', '2378962']">
        <inplay-title
          v-if="upcomingEventsMap[key]"
          :key="'title' + i"
          :category="upcomingEventsMap[key][0].eventType"
          :category-text="upcomingEventsMap[key][0].eventType"
        />
        <template v-for="(eventItem, index) in upcomingEventsMap[key]">
          <inplay-odds
            :key="'odds' + eventItem.market.id + index"
            :market="eventItem"
            :tv="!!eventItem.hasVideo"
            :to="
              eventItem &&
              eventItem.eventTypeId &&
              eventItem.market &&
              eventItem.market.competition &&
              eventItem.market.competition.id &&
              eventItem.event.id &&
              `/sportsbook/${eventItem.eventTypeId}/${eventItem.market.competition.id}/${eventItem.event.id}`
            "
            :show-date="true"
          />
          <!--          :to="
                  market.eventId
                  ? `/sportsbook/${markets.name}/${market.parentCategory.parentCategory}/${market.parentCategory._id}/${market.eventId}`
                  : `/sportsbook/${markets.name}/${market.parentCategory.parentCategory}/${market.parentCategory._id}`
                  "-->
        </template>
      </template>
    </v-card>
    <!-- <p
      v-if="upcomingMarkets && upcomingMarkets.length <= 0"
      class="white black--text py-4 px-3 text-center"
    >
      No matches at the moment.
    </p>
    <p v-if="!upcomingMarkets" class="white black--text py-4 px-3 text-center">
      No matches at the moment.
    </p> -->
  </v-skeleton-loader>
</template>
<script>
import { mapState } from 'vuex'
import InplayTitle from '@/components/inplay/InplayTitle'
import InplayOdds from '@/components/inplay/InplayOdds'
// import socket from '@/plugins/socket.client'
export default {
  name: 'Inplay',
  components: { InplayTitle, InplayOdds },
  data() {
    return {
      upcomingEventsMap: {}
    }
  },
  computed: {
    ...mapState({
      upcomingMarkets: (state) => state.inplay.upcomingMarkets,
      loading: (state) => state.inplay.loading,
      balanceSettings: (state) => state.settings.balanceSettings
    })
  },
  watch: {
    upcomingMarkets() {
      const eventsMap = {}
      this.upcomingMarkets.forEach((e) => {
        const event = e.eventTypeId
        eventsMap[event]
          ? (eventsMap[event] = [...eventsMap[event], e])
          : (eventsMap[event] = [e])
      })
      this.upcomingEventsMap = eventsMap
    }
  },
  // async created() {
  // },
  async beforeDestroy() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.item-odds {
  + .item-odds {
    border-top: 1px solid #e0e0e0;
  }
}
.v-card:nth-child(1) {
  border-radius: 20px 20px 15px 15px !important;
  border: none;
}
</style>
